

export const valueParse = (value) => {
    if (value === null || value === "") return "-"
    if (typeof(value) === "boolean") return value.toString();
    if (typeof(value) === "object" && value.length === 0) return "-"
    return value;
};